import type { StudioApiClient } from "../../../api.js";
import { FixKitPanel } from "../../../FixKitPanel.js";

export function V10FixKitPanel({
  api,
  claimId,
}: {
  readonly api: StudioApiClient;
  readonly claimId: string | null;
}) {
  return (
    <div className="v10-scan-embedded-panel" aria-label="Fix Kit">
      <FixKitPanel api={api} claimId={claimId} />
    </div>
  );
}
